import {
  CATEGORY_COLUMN,
  PRODUCT_COLUMN,
  NUMBER_OF_SOLD_GOODS_COLUMN,
  SALES_EXCL_VAT,
  ARTICLE_NUMBER,
  ARTICLE_NUMBER_2, SALES_INCL_VAT,
} from '../standard/StandardReportConsts';

export const TOP_SALES_HEADERS = [PRODUCT_COLUMN, CATEGORY_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, SALES_EXCL_VAT, SALES_INCL_VAT, ARTICLE_NUMBER, ARTICLE_NUMBER_2];